export default __webpack_public_path__ + "static/media/Cross.30382b4b.svg";